import React from 'react';
import InfoTooltip from './InfoTooltip';

export interface DmfTypeHeaderTooltipProps {
  /** Forwarded to InfoTooltip — override for a call site nested above InfoTooltip's own default. */
  zIndex?: number;
}

const DMF_TYPES_SOURCE_URL = 'https://www.law.cornell.edu/cfr/text/21/314.420';

/**
 * Field-level tooltip for the USDMF "Type" label — outlines what each of
 * FDA's five DMF types represents, matching DmfStatusHeaderTooltip.tsx's
 * pattern. Lists the full I-V set (2026-09-23 follow-up feedback), even
 * though LGM's own linking/matching only tracks II/IV
 * (docs/features/fda-usdmf-integration.md's MATCHABLE_DMF_TYPES) — FDA
 * Source Search's raw snapshot browsing isn't filtered the same way, so a
 * Type I/III/V record can genuinely appear there. Definitions cross-checked
 * against 21 CFR § 314.420 and FDA guidance, same sourcing already recorded
 * in docs/features/fda-usdmf-integration.md's own "TYPE definitions" table.
 */
const DmfTypeHeaderTooltip: React.FC<DmfTypeHeaderTooltipProps> = ({
  zIndex,
}) => (
  <InfoTooltip
    ariaLabel="About Type"
    zIndex={zIndex}
    interactive
    text={
      <span>
        I = Facility & Personnel (legacy, not tracked by LGM)
        <br />
        II = Drug Substance / API (tracked by LGM)
        <br />
        III = Packaging Material (not tracked by LGM)
        <br />
        IV = Excipient (tracked by LGM)
        <br />
        V = FDA-Accepted Reference Information (not tracked by LGM)
        <br />
        Source:{' '}
        <a
          href={DMF_TYPES_SOURCE_URL}
          target="_blank"
          rel="noopener"
          style={{ color: 'inherit', textDecoration: 'underline' }}>
          21 CFR § 314.420
        </a>
      </span>
    }
  />
);

export default DmfTypeHeaderTooltip;
